// Port of src/environments/environment.{prod,dev}.ts — same exported shape so
// ported service code reads `environment.x` unchanged. Selected by Vite mode
// (production build → prod values, dev server / --mode development → dev values).

const prod = {
  production: true,
  defaultUserEmail: 'shtest@songhunt.com',
  defaultUserPass: 'fdSa654%$#Dfs',
  defaultPlaylistName: 'My Songhunt playlist',

  emailsToLogout: [
    'shtest@songhunt.com',
    'sh_overwolf@songhunt.com',
    'v2sdemo@demo.com'
  ],

  toastSupportMessage: 'If the issue persists, please reach out to our support team at <a class="underline" href="mailto:songhunt@mypart.com">Songhunt Support</a>',

  baseUrl: 'https://www.mypart.com/mypart-webapp/',
  baseUrlWithApi: 'https://www.mypart.com/mypart-webapp/api/',
  baseUrlWithApiSh: 'https://www.mypart.com/mypart-webapp/api/sh/',

  // Spotify
  spotifyAuthEndpoint: 'https://accounts.spotify.com/authorize',
  spotifyTokenEndpoint: 'https://accounts.spotify.com/api/token',
  spotifyAppClientId: '5fd8804fa2c54c7381a745f4996a25b4',
  spotifyAppClientSecret: '0ae12af88e17464686a534ba2f4d730e',
  spotifyRefreshToken: 'AQAsH7VHJV2Li6VepxwtKogt-kjAC6iom27cL4TxbB5c5jIwOU3_wMmU4Mg08YO4BTPZ6DhSwiCjtYzFHSSyP649fEX0FkHGtG1N3tzmXyze3RxG6x2YLZASzHTmVD0IlrE',
  spotifyDefaultUserId: '6y3srerj60jwoc34mc3a0bkmj',
  spotifyRedirectUri: 'https://www.mypart.com/songhunt/',

  // Youtube
  youtubeDefaultUserAccessToken: '',
  youtubeDefaultUserRefreshToken: '',
  youtubeApiKey: '',
  youtubeClientId: '',
  youtubeProjectId: '',
  youtubeClientSecret: '',
  youtubeRedirectUri: ''
};

const dev: typeof prod = {
  ...prod,
  production: false,

  // Relative URLs: the Vite dev server proxies /mypart-webapp to
  // http://dev.mypart.com (see vite.config.ts) because the dev backend's CORS
  // policy only allows its own origin. The Angular dev config used absolute
  // dev.mypart.com URLs and hit that CORS wall from localhost.
  baseUrl: '/mypart-webapp/',
  baseUrlWithApi: '/mypart-webapp/api/',
  baseUrlWithApiSh: '/mypart-webapp/api/sh/',

  spotifyRedirectUri: 'http://dev.mypart.com/songhunt/',
};

export const environment = import.meta.env.MODE === 'production' ? prod : dev;
